import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useMagicLinkExchangeSessionIdToAuthTokenMutation } from '@occc-app/dataAccessLayer/auth/mutations';
import { MagicLinkExchangeSessionIdToAuthTokenMutation } from '@occc/graphql';

import MagicLinkAuthenticate from './MagicLinkAuthenticate';
import { authService } from './authService';

const RETURN_TO_DEFAULT = '/redirect-by-role';
const SESSION_ID_DEFAULT = '';

type MagicLinkQueryParams = (searchParams: string) => { returnTo: string; sessionId: string };

const magicLinkQueryParams: MagicLinkQueryParams = (searchParams) => {
  const params = new URLSearchParams(searchParams);
  const returnTo = params.get('returnTo');
  const sessionId = params.get('sessionId');

  return {
    returnTo: returnTo || RETURN_TO_DEFAULT,
    sessionId: sessionId || SESSION_ID_DEFAULT,
  };
};

const MagicLinkAuthenticateContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [error, setError] = useState(false);

  const { returnTo, sessionId } = magicLinkQueryParams(location.search);

  const onCompleted = (mutation: MagicLinkExchangeSessionIdToAuthTokenMutation) => {
    const { accessToken, refreshToken } = mutation.magicLinkExchangeSessionIdToAuthToken.tokens;
    authService.setTokens(accessToken, refreshToken);
    navigate(returnTo);
  };

  const onError = () => {
    setError(true);
  };

  const [magicLinkExchangeSessionIdToAuthToken] = useMagicLinkExchangeSessionIdToAuthTokenMutation({
    onCompleted,
    onError,
  });

  useEffect(() => {
    if (sessionId) {
      magicLinkExchangeSessionIdToAuthToken({
        variables: {
          input: {
            sessionId,
          },
        },
      });
    } else {
      setError(true);
    }

    // that code works incorrectly when all needed dependencies are added because
    // the "magicLinkExchangeSessionIdToAuthToken" is a new function on each render that
    // makes this code to be called multiple times
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO: redirect to log in page
  return <MagicLinkAuthenticate error={error} url='/' />;
};

export default MagicLinkAuthenticateContainer;
